import React from "react";
import { motion } from "framer-motion";
import * as LucideIcons from "lucide-react";
import { whyChooseUs } from "@/data/landing";
import { fadeUp, staggerContainer, staggerItem } from "@/lib/motion";
import Tilt from "@/components/landing/effects/Tilt";

const WhyChooseUs = () => {
    return (
        <section
            id="why-us"
            data-testid="why-us-section"
            className="section py-24 md:py-32 bg-[#070708]/70"
        >
            <motion.div
                className="orb"
                style={{
                    width: 500,
                    height: 500,
                    bottom: "10%",
                    left: "-180px",
                    background:
                        "radial-gradient(circle, rgba(0,229,255,0.22), transparent 60%)",
                }}
                animate={{ scale: [1, 1.2, 1], x: [0, 40, 0] }}
                transition={{ duration: 16, repeat: Infinity, ease: "easeInOut" }}
            />
            <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
                <motion.div {...fadeUp} className="max-w-3xl mb-14">
                    <span className="font-mono text-xs uppercase tracking-[0.3em] text-cyan-300">
                        04 / Why Choose Atvicon
                    </span>
                    <h2
                        data-testid="why-us-heading"
                        className="mt-4 font-display font-semibold text-white text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
                    >
                        Six reasons teams
                        <br />
                        <span className="text-grad-cyan">choose us first.</span>
                    </h2>
                </motion.div>

                <motion.div
                    variants={staggerContainer}
                    initial="initial"
                    whileInView="whileInView"
                    viewport={{ once: true, margin: "-80px" }}
                    className="grid md:grid-cols-2 lg:grid-cols-3 gap-5"
                >
                    {whyChooseUs.map((item, idx) => {
                        const Icon = LucideIcons[item.icon] || LucideIcons.Sparkles;
                        return (
                            <motion.div key={item.title} variants={staggerItem}>
                                <Tilt max={5} scale={1.02}>
                                    <div
                                        data-testid={`why-card-${idx}`}
                                        className="glass glass-hover rounded-2xl p-7 relative overflow-hidden group h-full"
                                    >
                                        <motion.div
                                            className="absolute -top-24 -right-24 w-48 h-48 bg-cyan-400/20 rounded-full blur-3xl opacity-0 group-hover:opacity-100 transition duration-500"
                                            animate={{ rotate: [0, 360] }}
                                            transition={{
                                                duration: 18,
                                                repeat: Infinity,
                                                ease: "linear",
                                            }}
                                        />
                                        <div className="relative">
                                            <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-cyan-400/20 to-violet-500/20 border border-white/10 grid place-items-center group-hover:rotate-12 group-hover:scale-110 transition duration-500">
                                                <Icon
                                                    className="h-5 w-5 text-cyan-300"
                                                    strokeWidth={1.75}
                                                />
                                            </div>
                                            <h3 className="mt-5 font-display font-semibold text-white text-xl">
                                                {item.title}
                                            </h3>
                                            <p className="mt-2 text-zinc-400 text-sm leading-relaxed">
                                                {item.desc}
                                            </p>
                                        </div>
                                    </div>
                                </Tilt>
                            </motion.div>
                        );
                    })}
                </motion.div>
            </div>
        </section>
    );
};

export default WhyChooseUs;
